import React__default, { useContext } from 'react';
import styled from 'styled-components';
import { O as OnCloseContext } from './Context-dY1G4PQg.js';
import { f as SHEET_CONTENT_Z_INDEX } from './Sheet.styles-DmpsK53T.js';
import { h as close } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { I as IconButton } from '../Button/IconButton/IconButton-B-_fri-k.js';

const SheetHeaderCloseButton = /*#__PURE__*/styled(IconButton).withConfig({
  componentId: "sc-storm-ui-40026394__sc-1g86e4g-0"
})(["background-color:", ";border:none;color:", ";:hover{background-color:", ";}"], ({
  theme
}) => theme.button.backgroundColor.transparent.default, ({
  theme
}) => theme.text.color.tertiary, ({
  theme
}) => theme.button.backgroundColor.transparent.default);
const Header = /*#__PURE__*/styled('header').withConfig({
  componentId: "sc-storm-ui-40026394__sc-1g86e4g-1"
})(["z-index:", ";position:sticky;top:0;max-width:100%;flex-wrap:wrap;display:flex;align-items:center;padding:", ";gap:", ";background-color:", ";border-bottom:", ";"], SHEET_CONTENT_Z_INDEX + 1, ({
  theme
}) => theme.spacing.medium.default, ({
  theme
}) => theme.spacing.medium.default, ({
  theme
}) => theme.surface.default, ({
  theme
}) => theme.border.subtle.default);
const HeaderContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-1g86e4g-2"
})(["display:flex;flex:1;flex-direction:row;flex-wrap:wrap;align-items:center;gap:", ";max-width:100%;"], ({
  theme
}) => theme.spacing.medium.default);
const ChildrenWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-1g86e4g-3"
})(["flex:1;"]);
function SheetHeader({
  closeButtonPosition = 'start',
  closeButtonLabel = 'Close sheet',
  actions,
  children
}) {
  const onClose = useContext(OnCloseContext);
  return /*#__PURE__*/React__default.createElement(Header, null, closeButtonPosition === 'start' && /*#__PURE__*/React__default.createElement(SheetHeaderCloseButton, {
    onClick: onClose,
    icon: close,
    label: closeButtonLabel
  }), /*#__PURE__*/React__default.createElement(HeaderContainer, null, /*#__PURE__*/React__default.createElement(ChildrenWrapper, null, children), actions && /*#__PURE__*/React__default.createElement("div", null, actions)), closeButtonPosition === 'end' && /*#__PURE__*/React__default.createElement(SheetHeaderCloseButton, {
    onClick: onClose,
    icon: close,
    label: closeButtonLabel
  }));
}

export { SheetHeader as S };
//# sourceMappingURL=SheetHeader-B8djCcxD.js.map
